import { useEffect, useState } from 'react'

import { EMPTY_LIST } from '../../constants/common'
import {
  getEmailAvailableAccounts,
  isServiceEmailAccount,
} from '../../utils/email'

import { getEmailAccounts } from './useEmailAccountsProvider.api'

export function useEmailAccountsProvider() {
  const [accounts, setAccounts] = useState(EMPTY_LIST)
  const [serviceAccount, setServiceAccount] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getEmailAccounts()
      .then(({ data }) => {
        const availableAccounts = getEmailAvailableAccounts(
          data.results.objects
        )

        setAccounts(
          availableAccounts.filter(account => !isServiceEmailAccount(account))
        )
        setServiceAccount(availableAccounts.find(isServiceEmailAccount) ?? null)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return {
    accounts,
    loading,
    serviceAccount,
  }
}
